













import { Component, Vue } from 'vue-property-decorator'
import Api from '@/utils/appInfo'
import { getWebviewHeight } from '@/utils/mUtil'
import { getQueryValue, isInApp } from '@ecom/utils'

@Component({
  components: {},
})
export default class App extends Vue {
  // $toast: any

  isFetchedUser: boolean = false
  PT: number = -1
  hiddenDown = getQueryValue(location.href, 'hiddenDown')
  inApp = isInApp()
  created() {
    // await this.$store.dispatch('autoLogin')
    this.fetchUserInfo()

    getWebviewHeight().then((data: any) => {
      const { navHeight, stateHeight } = data
      this.PT = navHeight + stateHeight
    })
  }

  // initSwiper() {

  //   new Swiper('.swiper-container', {
  //     loop: true,
  //     // 如果需要分页器
  //     pagination: '.swiper-pagination',
  //   })
  // }

  mounted() {
    //         this.initSwiper();
    // this.$toast({
    //   message: '提示',
    //   position: 'bottom',
    //   duration: 5000,
    // })
  }

  async fetchUserInfo() {
    try {
      await Api.getDeviceAndUserInfo()
    } catch (error) {
      console.log(error)
    } finally {
      this.isFetchedUser = true
    }
  }
}
